var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgCancel = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1253 -449)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-18756-3731a8.012,8.012,0,0,1,8-8,8.009,8.009,0,0,1,8,8,8,8,0,0,1-8,8A8.008,8.008,0,0,1-18756-3731Zm8,6a6,6,0,0,0,6-6,5.976,5.976,0,0,0-1.111-3.478l-8.359,8.364A5.965,5.965,0,0,0-18748-3725Zm-6-6a5.964,5.964,0,0,0,1.111,3.473l8.363-8.363A5.961,5.961,0,0,0-18748-3737,6.008,6.008,0,0,0-18754-3731Z",
    transform: "translate(20013 4192)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCancel, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/cancel.4035252b.svg";
export { ForwardRef as ReactComponent };